import React, { lazy } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';
import { paths } from 'components/LeftHandLayout/context';

const CloudIPAddresses = lazy(() => import('pages/network/CloudIPAddresses'));
const CloudBlockStorageDetails = lazy(
	() => import('pages/storage/CloudBlockStorageDetails'),
);
const ObjectStorage = lazy(() => import('pages/storage/CloudObjectStorage'));
const Firewalls = lazy(() => import('pages/services/Firewalls'));
const CloudBlockStorage = lazy(() => import('pages/storage/CloudBlockStorage'));

const VPNs = lazy(() => import('pages/services/VPNs'));

const AdvancedServices = lazy(() => import('pages/services/AdvancedServices'));
const FirewallRulesets = lazy(() => import('pages/services/FirewallRulesets'));
const CloudPrivateNetworks = lazy(
	() => import('pages/network/CloudPrivateNetwork/CloudPrivateNetwork'),
);

const PremiumBusinessEmail = lazy(
	() => import('pages/services/PremiumBusinessEmail'),
);

const NotFound = lazy(() => import('pages/NotFound'));

const ServicesRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/services/acronis"
				component={() => <Redirect to="/storage/backups-and-recovery" />}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/firewalls"
				component={Firewalls}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/firewall-presets"
				component={() => (
					<Redirect
						to={{
							pathname: paths.firewallRulesets,
						}}
					/>
				)}
			/>
			<RoleRestrictedRoute
				exact
				path={paths.firewallRulesets}
				component={FirewallRulesets}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/services/vpns/:uniqId?"
				component={VPNs}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/cloud-block-storage/:uniqId"
				component={CloudBlockStorageDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/cloud-block-storage"
				component={CloudBlockStorage}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/object-storage"
				component={ObjectStorage}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/services/cloud-private-networks"
				component={() => <Redirect to="/services/cloud-private-network" />}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/services/cloud-private-network"
				component={CloudPrivateNetworks}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/cloud-private-networks"
				component={() => (
					<Redirect to="/services/cloud-private-networks/storm" />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/advanced-services"
				component={AdvancedServices}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/managed-engineering"
				component={() => <Redirect to="/services/advanced-services" />}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/network/cloud-ip-addresses"
				component={CloudIPAddresses}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/services/ip-pools"
				component={() => <Redirect to="/network/cloud-ip-addresses" />}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route
				path="/services/ip-pools/create"
				component={() => (
					<Redirect to="/network/cloud-ip-addresses?create=true" />
				)}
			/>
			<RoleRestrictedRoute
				path="/services/ip-pools/:uniqId"
				component={({ match }) => (
					<Redirect to={`/network/cloud-ip-addresses/${match.params.uniqId}`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/services/premium-business-email"
				component={PremiumBusinessEmail}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default ServicesRouter;
